export default __webpack_public_path__ + "static/media/logoWhite.429eb603.png";